module.exports = __webpack_public_path__ + "img/fundingContainer1Model.c985753d.png";